import { debug, NetbankingAPI, toJS } from "aaa";
import { action, computed, observable } from "mobx";
import { EcosAPIClient, NetbankingAPIClient } from "network/APIClient";
import { IAccount } from "types/account";
import { IOffer } from "types/offer";
import { isJuniorProduct, isJuniorSmartSparen, isJuniorSpark7, isJuniorAccount } from "./OffersStore";

export class JuniorOffersStore {
    childId?: string;
    @observable offers?: IOffer[];
    @observable availableOffers?: IOffer[];
    @observable isLoading: boolean = false;
    @observable juniorAccounts?: IAccount[];
    constructor(childId?: string) {
        this.childId = childId;
    }

    @action async load() {
        if (!this.childId) {
            console.warn("[ChildOffersStore] No childId provided for loading offers");
            return;
        }

        const juniorAccountsTarget = NetbankingAPI.getAccounts(undefined, "JUNIOR_ACCOUNTS", this.childId);
        const availableJuniorOffersTarget = NetbankingAPI.getChildOffers(this.childId);

        this.isLoading = true;

        try {
            const response = await NetbankingAPIClient.requestType(juniorAccountsTarget);
            this.juniorAccounts = response as IAccount[];
            debug.log("### junior accounts", toJS(this.juniorAccounts));

            const availableResponse = await NetbankingAPIClient.requestType(availableJuniorOffersTarget);
            this.offers = availableResponse as IOffer[];
            debug.log("### available child offers", toJS(this.offers));

        } catch (error) {
            debug.log("Error loading child offers", error);
        } finally {
            this.isLoading = false;
        }
    }

    @action setChildId(childId: string) {
        this.childId = childId;
        // Clear offers when child changes
        this.offers = undefined;
    }



    @computed get hasJuniorSmartSparen() {
        return this.offers ? this.offers.some(offer => isJuniorSmartSparen(offer.channelProduct)) : false;
    }

    @computed get hasJuniorSpark7() {
        return this.offers ? this.offers.some(offer => isJuniorSpark7(offer.channelProduct)) : false;
    }

    @computed get hasJuniorProducts() {
        return this.offers ? this.offers.some(offer => isJuniorProduct(offer.channelProduct)) : false;
    }

    @computed get juniorOffers() {
        return this.offers ? this.offers.filter(offer => isJuniorProduct(offer.channelProduct)) : [];
    }

    @computed get filteredJuniorAccounts() {
        return this.juniorAccounts ? this.juniorAccounts.filter(account => isJuniorAccount(account)) : [];
    }
}



// WEBPACK FOOTER //
// ./src/stores/JuniorOffersStore.ts